
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getAvoidLoginUrl, addWhiteSign } from "@/api/iousServices";
import { getCompanyDtl, jump2Quota, jump2Repayment, toQuotaResDto } from '@/api/customerManage'
import { openNewPage, openFDWhitePage, getSessionItem, setSessionItem, backHomes } from '@/utils/h5ToApp'
import { getSyDictDataInfo, updateUserOtherInfoFCD } from '@/api/commonConfig'

Component.registerHooks(['beforeRouteEnter'])
@Component({
  name: 'IOUsAuthorize',
  components: {}
})
export default class IOUsAuthorize extends Vue {
  @Getter companyId!: string
  @Getter mobile!: string
  @Getter userId!: string

  type = 1 // 操作类型 1:'去出额' , 2:'去借款', 3:'去还款'
  merchantId = '' // 选中的客户编号
  companyName = '' // 当前公司名称
  times = 5 // 倒计时
  webshowFlag = ''
  whiteSignTime = ''
  cykjSource = ''
  endTime = ''
  isHidden = false

  today = new Date()

  nowDate = (this.today.getFullYear()) + '年' + (this.today.getMonth() + 1) + '月' + this.today.getDate() + '日' + ' '

  created () {
    window.addEventListener("visibilitychange", () => {
      this.isHidden = document.hidden
    })
    this.type = Number(this.$route.query.type)
    this.merchantId = this.$route.query.merchantId as string
    this.webshowFlag = this.$route.query.webshow as string;
    this.cykjSource = this.$route.query.cykjSource as string;

    this.timesFun()
    this.getCompanyInfo()
  }

  @Watch('isHidden')
  changeHidden (val: boolean) {
    // 处理白条页面回退地址
    getSessionItem('cykjSource').then(res => {
      console.log('cykjSource--------------', res)
      if (res === 'iousServices' || res === 'homes') {
        this.$router.back()
        setTimeout(() => {
          setSessionItem('cykjSource', '')
        }, 500)
      // } else {
      //   // this.$router.push({
      //   //   path: '/homes'
      //   // })
      //   backHomes()
      }
    })
  }

  beforeRouteEnter (to, from, next) {
    next(vm => {
      getSyDictDataInfo({dictTypeId: 'tradeSignTime'}).then((res: any) => {
        vm.times = res.data[0].dataId || 1
      })
    })
  }

  timesFun () {
    let timeIn = setInterval(() => {
      this.times--
      if (this.times === 0) {
        clearInterval(timeIn)
      }
    }, 1000)
  }

  // 1还款入口 2授信入口 3借款入口
  fdfreeLogin(flag = '') {
    const { orderId, tradeMoney } = this.$route.query
    let params = {
      companyId: this.companyId,
      orderId,
      tradeMoney,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        let encodeUrl = encodeURI(data.responseData.redirectUrl)
        // 完成授信流程，webShow=1或3替换成2
        if (encodeUrl.indexOf('webShow=1') > -1 || encodeUrl.indexOf('webShow=3') > -1) {
          encodeUrl.replace(/webShow=[d{1,3}]/,'webShow=2')
        }
        let isQuery = encodeUrl.indexOf('?') > -1
        let reg = /webshow=/
        let url = `${encodeUrl}${isQuery? '&' : '?'}${reg.test(encodeUrl) ? '' : `webShow=${flag}`}&userPhone=${this.mobile}&cykjSource=${this.cykjSource}` + (flag == '' ? `&companyName=${this.companyName}` : '')
        // openNewPage({url})
        // window.location.href = url
        openFDWhitePage({url:encodeURI(url)})
        console.log('getAvoidLoginUrl=',url);
      }
    }).catch((e) => {
      if (e.message !== '取消重复请求') this.$toast('请先绑定版本码')
    })
  }

  /**
   * @description: 获取公司信息
   * @param {*}
   * @return {*}
   */
  getCompanyInfo () {
    getCompanyDtl({companyId: this.companyId}).then(res => {
      this.companyName = res.data.companyName
    })
  }

  sureFunc () {
    // this.fdfreeLogin(this.webshowFlag);
    // 签署授权书记录
    addWhiteSign().then((res =>{
      const { code } = res
      if( code === "000000") {
        window.localStorage.setItem('isSign','1')
        this.fdfreeLogin(this.webshowFlag);
      }
    }))
    //  跳转个人信息使用授权书页面
    // updateUserOtherInfoFCD({userId:this.userId}).then((res)=>{
    //   if(res.code==='000000'){
    //     this.$router.push({
    //       path: '/financialServices',
    //     })
    //   }else {
    //     this.$toast('个人信息授权失败')
    //   }
    // })
  }

  /**
   * 去出额
   * @param isAuthorized 是否授权，默认false
   */
  toQuota () {
    const obj = {
      companyId: this.companyId,
      merchantId: this.merchantId
      // isAuthorized: true
    }
    jump2Quota(obj).then((res) => {
      if (res.code === '000000') {
        //    跳转到免登录产融h5
        this.toFreeLogin(res.data)
      }
    })
  }

  /**
   * 跳转到免登录页面
   * @param data 后端接口返回数据
   */
  toFreeLogin (data: toQuotaResDto) {
    // let redirectUrl = 'http://172.16.101.69:8088/#/loginFree?as=CYTCS001&cs=1000&orderId=24b3bf8c-1570-455f-9da8-7b33efe62283&client=0&industryType='
    openNewPage({url: encodeURI(data.redirectUrl)})
  }
}
